import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DownFillIcon } from '~svg/index';
import PropTypes from 'prop-types';
import '../../../component/common/darkPopOver/darkPopOver.scss';
const DarkDateDropdown = (props) => {
  const {
    children,
    className,
    label,
    icon,
    svgIcon,
    boxColor,
    name,
    disable = false,
    show,
    direction,
    parentClass,
    onclick,
    placement = 'end',
    labelClassName = '',
  } = props;

  return (
    <div className={`filter-panel-container  dropdown ${className} `}>
      <div
        className={`col-11 h-100 filter-design d-flex flex-row justify-content-between px-2 ${
          direction === 'rtl' ? 'px-sm-3 px-2' : 'px-lg-3 px-sm-2 px-2'
        } ${boxColor} `}
        onClick={onclick}
      >
        {svgIcon}
        <span
          className={`font-xl-small font-md-smaller font-xsmall text-nowrap ${labelClassName}`}
        >
          <FormattedMessage id={label} />
        </span>
        <DownFillIcon variant="svg-md-small svg-sm-small svg-xs-small svg-tiny" />
      </div>
      {disable === false && (
        <>
          <div
            className={`
					 d-flex
					 justify-content-sm-center ${parentClass} ${
              placement === 'center'
                ? 'justify-content-center'
                : 'justify-content-end'
            } align-items-center position-absolute w-100`}
            style={{ top: 48 }}
          >
            <div
              className={`col-11 m-2 dropdown-menu font-xl-normal font-sm-msmall font-smaller ${boxColor} darkDatedropdown-position shadow ${
                show === true && 'show'
              }`}
              style={{ zIndex: 1 }}
            >
              {children}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

DarkDateDropdown.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  boxColor: PropTypes.string,
  children: PropTypes.node,
  name: PropTypes.string,
};
DarkDateDropdown.defaultProps = {
  className: 'search-box position-relative',
  icon: '',
  label: '',
  boxColor: 'bg-primary-dark-lighter',
  children: '',
  name: 'darkDateDropDown',
};

export default DarkDateDropdown;
